import * as React from 'react';
import { Page } from '../../components/atoms/layout/Page';
import { PageHeader } from '../../components/atoms/layout/PageHeader';
import { PageBody } from '../../components/atoms/layout/PageBody';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { CourseListPageState } from './states/CourseListPageState';
import { CourseList } from '../../components/molecules/courses/index/CourseList';
import { parseQueryParams, RouteLocation } from '../../types/location';
import './courseListPage.module.scss';
import { LoaderRow } from '../../components/atoms/layout/LoaderRow';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { authenticated } from '../../components/hocs/authenticated';
import { CourseListCard2 } from '../../components/molecules/courses/index/CourseListCard2';

type Props = {
    location: RouteLocation;
};

@withNavigation(NavigationSpecs.home('white'))
@authenticated
@observer
export class CourseListPage extends React.Component<Props> {
    @observable pageState = new CourseListPageState();

    async componentDidMount() {
        const { preview } = parseQueryParams(this.props.location);
        this.pageState.init(preview === 'true');
    }

    render() {
        const { courses } = this.pageState;
        return (
            <Page styleName="page">
                <PageHeader title="COURSES" subTitle="コース" />
                <PageBody styleName="page-body">
                    {courses.loading && <LoaderRow />}
                    <CourseList>
                        {courses
                            .getOrElse([])
                            .map((course) => (
                                <CourseListCard2 key={course.id} course={course} styleName="course-list-card" />
                            ))}
                    </CourseList>
                </PageBody>
            </Page>
        );
    }
}
